var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.38 14.783l.12-.136c.158-.175.237-.407.22-.643-.02-.234-.13-.45-.308-.605l-2.394-2.07c-.27-.233-.656-.28-.976-.12l-1.347.676L9.23 9.422l.68-1.352c.154-.32.106-.7-.124-.968L7.7 4.702c-.153-.18-.372-.29-.607-.303-.235-.015-.466.064-.643.22L4.84 6.057c-1.408 1.41.827 4.646 3.177 6.99 1.116 1.147 2.38 2.142 3.757 2.957.652.414 1.396.66 2.165.715.41.018.813-.136 1.108-.424l.062-.065.107-.122c.326.336.532.775.58 1.246-.072.27-.255.496-.503.623-3.388 2.162-7.81 1.754-10.746-.992C1.613 14.24.91 9.853 2.843 6.33c1.932-3.526 6.007-5.293 9.9-4.296 3.895.998 6.618 4.507 6.617 8.526.077 1.036-.162 2.07-.686 2.966-.306.38-.247.935.132 1.24.38.307.934.247 1.24-.132.784-1.208 1.16-2.636 1.074-4.074C21.12 4.728 16.392 0 10.56 0 4.728 0 0 4.728 0 10.56c0 5.832 4.728 10.56 10.56 10.56 1.99.006 3.942-.558 5.623-1.624.705-.39 1.2-1.077 1.347-1.87.072-1.077-.355-2.123-1.15-2.843z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fa9b22cfd863cdbafc66d833add7b06d.svg";
export { ForwardRef as ReactComponent };